import '@babel/polyfill'
import $ from 'jquery'
import smoothscroll from 'smoothscroll-polyfill'
import svgxuse from 'svgxuse'
// import openModal from './modal'
import throttle from 'lodash/throttle'
import AOS from 'aos'
import debounce from './debounce'
import fundingForm from './fundingModal'
// import { createPips } from './slider'

import {
  animateHeroImage,
  animateNextPost,
  animateOnScroll,
} from './animationFunctions'
import {
  createHeroesArray,
  // lazyLoadHeroImages,
} from './hero'
import {
  openVideoModal,
  openMenuModal,
  openFundingModal,
  openApplyModal,
} from './modal'
import {
  handleNavLinks,
} from './navLinks'
import {
  hideApplyFormLabels,
  hideFundingFormLabels,
} from './forms'
import {
  postsSetup,
  handlePips,
  setActivePost,
  findActivePost,
  initializeButtons,
} from './heroSlider'

import './payments'
import {
  chooseAmount,
  setupPaymentLinks,
} from './payments'

const isHome = document.body.classList.contains('home')
const isSingle = document.body.classList.contains('single')
const isSponsorsPage = document.body.classList.contains('page-template-page-sponsors')
let isAbout = document.body.classList.contains('page-template-page-about')
if (!isAbout) {
  isAbout = document.body.classList.contains('page-template-template-content')
}


smoothscroll.polyfill()
chooseAmount()
hideFundingFormLabels()
// Export functions to call from inline scripts
export {
  setupPaymentLinks,
  hideFundingFormLabels,
  hideApplyFormLabels,
}

if (isHome) {
  hideApplyFormLabels()
  // lazyLoadHeroImages()
}

if (isHome) {
  AOS.init({
    offset: 200,
    duration: 700,
    disable: 'phone',
    easing: 'ease-in-out-back',
  })
}
const scrollTos = [...document.querySelectorAll('.js-scroll-to')]

const scrollToEventHandler = function (event) {
  if (event.type === 'click') {
    if (isHome) {
      event.preventDefault()
      const target = event.target.getAttribute('href').split('#')[1]
      document.querySelector(`#${target}`).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  } else {
    window.location = event.target.getAttribute('href')
  }
}

scrollTos.forEach((link) => {
  link.addEventListener('click', (e) => {
    scrollToEventHandler(e)
  })
})

function isVisible(ele, mod) {
  // positive modifier triggers animations earlier
  const {
    top,
    bottom,
  } = ele.getBoundingClientRect()

  const t = top + mod
  const vHeight = window.innerHeight || document.documentElement.clientHeight

  return (t > 0 || bottom > 0) && t < vHeight
}

if (isHome) {
  const sectionsWrap = document.querySelector('.u-sections-wrapper')
  const hero = document.querySelector('.c-hero')
  const heroHeight = hero.getBoundingClientRect().height
  sectionsWrap.setAttribute('style', `top: ${heroHeight}px`)
  sectionsWrap.classList.remove('u-hide')
  const navLinks = [...document.querySelectorAll('c-nav__link--menu')]
  const sections = [...sectionsWrap.getElementsByTagName('section')]
  // / hero animation
  animateOnScroll(hero, heroHeight)
  // Scroll event listener
  const throttleAnimateOnScroll = throttle(animateOnScroll, 10)
  window.addEventListener('scroll', (e) => {
    throttleAnimateOnScroll(hero, heroHeight)
  })
}

// hero images javascript
function cycleHeroImages(curr, next) {
  animateHeroImage(curr, next)
}

if (isHome) {
  const heros = createHeroesArray()
  let currentHero = 0
  let nextHero = 1
  let counter = 0

  function triggerHeroAnimation() {
    counter++
    if (counter > 500) {
      if (nextHero == heros.length) {
        cycleHeroImages(heros[nextHero - 1], heros[0])
        currentHero = 0
        nextHero = 1
      } else {
        cycleHeroImages(heros[currentHero], heros[nextHero])
        nextHero++
        currentHero++
      }
      counter = 0
    }
    requestAnimationFrame(triggerHeroAnimation)
  }
  requestAnimationFrame(triggerHeroAnimation)
}

// end hero images javascript

// menu javascript

// if (isHome || isSponsorsPage || isSingle || isAbout) {
const menuModal = document.querySelector('.c-modal__menu')
const menuButton = document.querySelector('.c-nav__menu-button')
menuButton.addEventListener('click', () => {
  openMenuModal(menuModal, 'c-modal--active')
})
// }

// Funding Modal javascript

// Funding Modal Listener

if (!isHome) {
  const openModalButton = document.querySelector('.c-nav__support')
  const modal = document.querySelector('.c-funding-modal')
  openModalButton.addEventListener('click', () => {
    openFundingModal(modal, 'c-modal--active')
  })
} else {
  const openModalButtons = [...document.querySelectorAll('.c-nav__link--support-hero')]
  const modal = document.querySelector('.c-funding-modal')
  openModalButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      openFundingModal(modal, 'c-modal--active')
    })
  })
}

// apply modal javascript

if (isHome && document.querySelector('.c-apply__btn')) {
  const applyModalButton = document.querySelector('.c-apply__btn')
  const applyModal = document.querySelector('.c-apply-modal')
  applyModalButton.addEventListener('click', (e) => {
    openApplyModal(applyModal, 'c-modal--active')
  })
}

if (isHome) {
  const videoModalTrigger = document.querySelector('.c-mindset__unit--2')
  const videoModal = document.querySelector('.c-modal__video')
  videoModalTrigger.addEventListener('click', (e) => {
    e.preventDefault()
    openVideoModal(videoModal, 'c-modal--active')
  })
}

if (document.querySelector('.js-open-modal')) {
  const bankResponseModal = document.querySelector('.c-response-modal')
  openApplyModal(bankResponseModal, 'c-modal--active')
}

// slider logic

if (isHome) {
  const posts = [...document.querySelectorAll('.c-goals__post')]
  const postsImages = [...document.querySelectorAll('.c-goals__unit--1')]
  const postsCopy = [...document.querySelectorAll('.c-goals__unit--2')]
  const pipsWrapper = document.querySelector('.c-slider__pips-wrapper')
  const slider = document.querySelector('.c-slider__wrapper')
  if (slider) {
    const postsObject = postsSetup(postsImages, postsCopy, pipsWrapper)
    setActivePost(postsObject, postsObject[0])
    handlePips(postsObject)
    initializeButtons(postsObject)
    postsObject.forEach((post) => {
      post.pip.addEventListener('click', (e) => {
        const activePost = findActivePost(postsObject)
        const associatedPost = post
        if (associatedPost !== activePost) {
          animateNextPost(activePost, associatedPost)
          setActivePost(postsObject, associatedPost)
          handlePips(postsObject, e.target)
        }
      })
    })
  }
}

// Results

if (isHome) {
  // Results section javascript

  // utility functions

  function activateElement(el) {
    el.classList.remove('u-hide')
    resultsProgress.style.setProperty('--percentage', `${el.dataset.percentage}%`)
  }

  function deactivateElement(el) {
    el.classList.add('u-hide')
  }

  // results javascript

  function objectifyResults() {
    const resultsTabs = [...document.querySelectorAll('.c-results__tab')]
    const resultsItems = [...document.querySelectorAll('.c-results__item')]
    const resultsCopy = [...document.querySelectorAll('.c-results__item--copy')]

    const resultsObject = []

    for (let i = 0; i < resultsTabs.length; i++) {
      const result = {
        item: resultsItems[i],
        tab: resultsTabs[i],
        copy: resultsCopy[i],
        index: i,
      }
      resultsObject.push(result)
    }
    return resultsObject
  }

  function setFirstResult(obj) {
    let current
    obj.forEach((element) => {
      if (element.index === 0) {
        current = element
        current.tab.classList.add('c-results__tab--active')
      } else {
        deactivateElement(element.item)
        deactivateElement(element.copy)
      }
    })
    return current
  }
  // results buttons javascript
  var resultsProgress = document.querySelector('.c-results__progress')
  if (isHome && resultsProgress) {
    var resultsProgress = document.querySelector('.c-results__progress')
    const resultsButtons = [
      document.querySelector('.c-results__previous'),
      document.querySelector('.c-results__next'),
    ]
    const resultsObject = objectifyResults()

    let currentResult = setFirstResult(resultsObject)

    // results tab functionality

    resultsObject.forEach((result) => {
      result.tab.addEventListener('click', (e) => {
        e.preventDefault()
        let activeTab
        resultsObject.forEach((res) => {
          if (res.tab == e.currentTarget) {
            currentResult = res
            activeTab = res.tab
          } else {
            deactivateElement(res.copy)
            deactivateElement(res.item)
            res.tab.classList.remove('c-results__tab--active')
          }
        })
        activeTab.classList.add('c-results__tab--active')
        activateElement(currentResult.copy)
        activateElement(currentResult.item)
      })
    })

    // results button functionality

    resultsButtons.forEach((button) => {
      // add an event listener to each button
      button.addEventListener('click', (e) => {
        e.preventDefault()
        // prevent default behavior
        const modifier = button.classList.contains('c-results__next') ? 1 : -1
        // check the button classList. If it contains c-results__next, modifier is set to 1.
        // otherwise it is set to -1.
        let foundNextPost = false
        // create a condition to determine whether the post is the last post, in which
        // case the next post will not be loaded.
        const isFinalPost = currentResult.index + 1 === resultsObject.length

        resultsObject.forEach((result) => {
          // loop through the results
          // results is an array of objects with the following properties
          //
          // item: the big number part of the result,
          // tab: the tab that is associated with this result
          // copy: the text that is associated with this result, displayed on the tab
          // index: the index of the result
          result.tab.classList.remove('c-results__tab--active')
          if (result.index === currentResult.index + modifier && !foundNextPost) {
            // currentResult houses the result object which is currently being displayed.
            // we take the index and add the modifier.
            // if we are looking for the next result, the modifier is 1, if we
            // are looking for the previous result, it is -1
            // if the result currently being iterated on matches, it is deemed to be the next post
            foundNextPost = true
            currentResult = result
          } else {
            // otherwise add a hide class to the element
            deactivateElement(result.copy)
            deactivateElement(result.item)
          }
        })
        // the current class get unhidden
        activateElement(currentResult.copy)
        activateElement(currentResult.item)
        currentResult.tab.classList.add('c-results__tab--active')
      })
    })
  }
} // End of Results Section

fundingForm()
